<template>
  <div class="dps-body-container">
    <div class="flex-row align-center">
      <div class="dps-body-left-container">
        <div class="dps-body">
          Download the SmartAC.com PRO app from
          <a href="https://apps.apple.com/us/app/smartac-com-pro/id1536845908">Apple’s App Store</a> or
          <a href="https://play.google.com/store/apps/details?id=com.smartac.pro.app.com">Google’s Play Store</a>
        </div>
        <div class="dps-store-container">
          <a
            class="app-store-link"
            href="https://play.google.com/store/apps/details?id=com.smartac.pro.app.com"
          >
            <img
              class="app-store"
              src="@shared/assets/img/general/google-play.svg"
              alt="Google Play Store"
            >
          </a>
          <a
            class="app-store-link"
            href="https://apps.apple.com/us/app/smartac-com-pro/id1536845908"
          >
            <img
              class="app-store"
              src="@shared/assets/img/general/app-store.svg"
              alt="Apple App Store"
            >
          </a>
        </div>
        <div
          v-if="showQR"
          class="dps-qr-container"
        >
          <div class="dps-qr-text">
            SCAN TO
            <br>
            DOWNLOAD
          </div>
          <img
            src="@shared/assets/img/general/right-white.svg"
            alt="Right White"
          >
          <img
            class="pro-qr"
            src="@shared/assets/img/pro/qr.png"
            alt="Pro App QR Code"
          >
        </div>
      </div>
      <img
        class="phone-screenshot"
        src="@shared/assets/img/pro/home.png"
        alt="PRO Home Screen"
      >
    </div>
    <div class="dps-body-bottom-container">
      <div class="dps-app-container">
        <img
          class="app-screenshot"
          src="@shared/assets/img/pro/map.png"
          alt="PRO Map View"
        >
        <div class="dps-text-container">
          Map Based
          <br>
          Onboarding
        </div>
      </div>
      <div class="dps-app-container">
        <img
          class="app-screenshot"
          src="@shared/assets/img/pro/job.png"
          alt="PRO Map View"
        >
        <div class="dps-text-container">
          <div class="dps-text-top-header">
            Track your
          </div>
          <div class="dps-text-bottom-header">
            Upcoming Installs
            <div class="dps-text-small">
              (with select CRM integrations)
            </div>
          </div>
        </div>
      </div>
      <div class="dps-app-container">
        <img
          class="app-screenshot"
          src="@shared/assets/img/pro/detail.png"
          alt="PRO Map View"
        >
        <div class="dps-text-container">
          Member Details
          <br>
          on the Go
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProAppBody',
  props: {
    showQR: Boolean,
  },
};
</script>

<style lang="scss">

.dps-body-container {
  background-color: $BLACK;
  color: $WHITE;
  padding: 55px 78px 100px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  .dps-body-left-container {
    margin-right: 40px;

    .dps-body {
      font-size: 1.85rem;
      font-weight: 500;

      a {
        color: $WHITE;
        text-decoration: underline;
      }
    }

    .dps-store-container {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 50px;

      .app-store-link {
        &:first-child {
          margin-right: 16px;
        }

        .app-store {
          width: 135px;
          height: 40px;
        }
      }
    }

    .dps-qr-container {
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;

      .dps-qr-text {
        font-size: 0.625rem;
        color: $WHITE;
        font-weight: 600;
        margin-right: 12px;
      }

      .pro-qr {
        width: 50%;
        margin-left: 18px;
      }
    }
  }

  .phone-screenshot {
    width: 40%;
  }

  .dps-body-bottom-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 62px;

    .dps-app-container {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      position: relative;
      min-height: 400px;

      .app-screenshot {
        width: 80%;
        position: absolute;
        top: -20px;
      }

      .dps-text-container {
        width: 100%;
        text-align: center;
        background-color: $N70;
        padding: 42px 0 20px;
        border-radius: 2px;
        font-weight: 600;
        max-height: 110px;
      }

      .dps-text-top-header {
        margin-top: -8px;
        align-items: flex-start;
      }

      .dps-text-bottom-header {
        margin-top: 8px;
        line-height: 1px;
      }

      .dps-text-small {
        margin-top: 20px;
        font-size: .70rem;
        margin-bottom: 15px;
      }
    }
  }
}

@media (max-width: 600px) {
  .dps-body-container {
    padding: 24px 16px 40px;

    .flex-row.align-center {
      flex-direction: column;
      align-items: center;
    }

    .dps-body-left-container {
      margin-right: 0;
      text-align: center;
      width: 100%;

      .dps-body {
        font-size: 1.1rem;
        line-height: 1.5;
      }

      .dps-store-container {
        margin-top: 20px;
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 12px;
        justify-content: center;

        .app-store-link {
          &:first-child {
            margin-right: 0;
          }

          .app-store {
            width: 120px;
            height: 36px;
          }
        }
      }

      .dps-qr-container {
        margin-top: 16px;

        .pro-qr {
          width: 35%;
        }
      }
    }

    .phone-screenshot {
      display: none;
    }

    .dps-body-bottom-container {
      display: none;
    }
  }
}
</style>
